


















































import Vue from 'vue'
import api from '@/api'
import store from '@/store'
import actions from '@/actions'

import {
  ImageFile, SignUp, Customer, Room,
} from '../types'

export default Vue.extend({
  name: 'AdminSignupDetail',

  data: () => ({
    imageObjectUrls: {} as { [key: string]: string },
    store,
  }),

  computed: {
    customer(): Customer {
      return (this.signup && this.signup.customer) || {}
    },
    inspirationPhotos(): Array<ImageFile> {
      return (this.signup.images || []).filter(p => p.type === 'inspiration')
    },
    roomPhotos(): Array<ImageFile> {
      return (this.signup.images || []).filter(p => p.type === 'room')
    },
    dimensionsPhotos(): Array<ImageFile> {
      return (this.signup.images || []).filter(p => p.type === 'dimensions')
    },
    photos(): Array<ImageFile> {
      return this.signup.images || []
    },
    signup(): SignUp {
      return store.state.selectedSignup
    },
    room(): Room {
      return (this.signup && this.signup.room) || {} as Room
    },
  },

  methods: {
    srcFor(image: ImageFile): string | null {
      return this.imageObjectUrls[image.filename]
    },
  },

  async mounted() {
    const { id } = this.$route.params
    store.setSelectedSignup(await api.getSignup(id))
    this.imageObjectUrls = await actions.fetchSignupAdminImages(id, this.photos)
    window.scrollTo(0, 0)
  },
})
